import { Component, EventEmitter, Output } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { NotificationPermissionStatus, NotificationsBloc } from '@kp/notifications/notifications.bloc';

@Component({
  selector: 'kp-modal-reminders',
  templateUrl: './modal-reminders.component.html',
  styleUrls: ['./modal-reminders.component.scss'],
})
export class ModalRemindersComponent {
  @Output() closeClicked = new EventEmitter<NotificationPermissionStatus>();
  showInitialCase = true;
  showNotNowCase = false;

  constructor(private _afMessaging: AngularFireMessaging, private _notificationsBloc: NotificationsBloc) {}

  notNow() {
    this.showInitialCase = false;
    this.showNotNowCase = true;
  }

  dismissModal() {
    this.showNotNowCase = false;
    this.closeClicked.emit(NotificationPermissionStatus.notNow);
  }

  async enable() {
    // Don't need to check first visit or Notification state as user likely cannot get this unless
    // they were already likely in the proper state to need to clear old notifications
    this._notificationsBloc.clearIoNotifications();
    await this._notificationsBloc.requestPermission();
    this.closeClicked.emit(NotificationPermissionStatus.enabled);
  }
}
